/**
 * GlowSeason quick preview for Atelier product variants.
 * Changes only the currently shown slideshow slide. Shopify's native
 * variant-picker and media-gallery continue to handle the final product update.
 */
const loadedUrls = new Set();

function readMap(gallery) {
  const node = gallery?.querySelector('script[data-glow-variant-media-map]');
  if (!node?.textContent) return null;
  try { return JSON.parse(node.textContent); } catch { return null; }
}

function preloadVariantMedia() {
  for (const gallery of document.querySelectorAll('media-gallery[data-glow-media-order]')) {
    const entries = readMap(gallery);
    if (!entries) continue;
    for (const entry of Object.values(entries)) {
      if (!entry?.src || loadedUrls.has(entry.src)) continue;
      loadedUrls.add(entry.src);
      const img = new Image();
      img.decoding = 'async';
      img.src = entry.src;
    }
  }
}

// Preload up to the store's variant preview images while the browser is idle.
// Regular gallery images remain under Atelier's native rendering and lazy loading.
const schedulePreload = () => {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(preloadVariantMedia, { timeout: 2500 });
  } else {
    window.setTimeout(preloadVariantMedia, 800);
  }
};
if (document.readyState === 'complete') schedulePreload();
else window.addEventListener('load', schedulePreload, { once: true });

// The change event is fired by the real radio input: we don't synthesize clicks
// or alter variant IDs, add-to-cart forms, pricing or the source data.
document.addEventListener('change', (event) => {
  const target = event.target;
  if (!(target instanceof HTMLInputElement) || target.type !== 'radio') return;
  const picker = target.closest('variant-picker');
  if (!picker || picker.dataset.templateProductMatch !== 'true') return;
  if (target.closest('product-card, quick-add-dialog')) return;

  const variantId = target.dataset.variantId;
  if (!variantId) return;
  const section = picker.closest('.shopify-section');
  const gallery = section?.querySelector('media-gallery[data-glow-media-order]');
  if (!gallery) return;

  const map = readMap(gallery);
  const mediaId = map?.[variantId]?.media;
  if (!mediaId) return; // Native Atelier handles variants without a featured image.

  const order = (gallery.dataset.glowMediaOrder || '').split(',');
  const index = order.indexOf(String(mediaId));
  if (index < 0) return; // e.g. option to hide variant-specific images.

  const slideshow = gallery.slideshow;
  if (!slideshow || typeof slideshow.select !== 'function') return;
  try {
    const result = slideshow.select(index, undefined, { animate: false });
    if (result && typeof result.catch === 'function') result.catch(() => {});
  } catch (error) {
    console.warn('[GlowSeason] Native gallery will handle this variant.', error);
  }
}, true);
